var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Drawer",
    {
      attrs: {
        drawer: _vm.drawer,
        title: "操作记录",
        size: 563,
        direction: "rtl",
      },
      on: { close: _vm.close },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "view",
        },
        [
          _c(
            "div",
            { staticClass: "log-content" },
            _vm._l(_vm.dataList, function (item, index) {
              return _c("div", { key: index, staticClass: "log-item" }, [
                _c("div", { staticClass: "log-top" }, [
                  _c("img", {
                    staticClass: "avatar",
                    attrs: { src: require("@/assets/images/bill/avatar.png") },
                  }),
                  _c("div", { staticClass: "log-created" }, [
                    _c("p", [_vm._v(_vm._s(item.createdName))]),
                    _c("p", [_vm._v(_vm._s(item.createdOn))]),
                  ]),
                  _c(
                    "div",
                    { class: ["indication", `indication${item.rcordType}`] },
                    [_vm._v(_vm._s(item.rcordTypeName))]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "log-bottom" },
                  [
                    _c("p", { staticClass: "bottom-title" }, [
                      _vm._v(_vm._s(item.rcordTypeName) + "："),
                    ]),
                    _vm._l(item.editJson, function (a, aIndex) {
                      return _c(
                        "div",
                        { key: aIndex, staticClass: "detail-item" },
                        [
                          _c("div", { staticClass: "log-label flex_c_c" }, [
                            _vm._v(_vm._s(a.propertyName)),
                          ]),
                          _c("div", { staticClass: "log-originalValue" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatText(a.propertyName, a.originalValue)
                              )
                            ),
                          ]),
                          a.newValue
                            ? [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/bill/log-arrow.png"),
                                  },
                                }),
                                _c("div", { staticClass: "log-newValue" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formatText(a.propertyName, a.newValue)
                                    )
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                ),
              ])
            }),
            0
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }